// ** Initial State
const initialState = {
  allConferenceData: [],
  conferenceData: null,
  conferenceeventDataWithPagintion: {
  "limit": 30,
  "page": 0,
  "total_pages": null,
  "total_records": null,
  "data": null
  },
  pageLoader:true
}

const conferenceevent = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_CONFERENCE_EVENT_LIST':
      return { ...state, allConferenceData: action.data }
    case 'GET_CONFERENCE_EVENT_DATA':
      return { ...state, conferenceData: action.data }
    case 'GET_ALL_CONFERENCEEVENT_WITH_PAGINATION':
      return { ...state, conferenceeventDataWithPagintion: action.data, pageLoader: false }
    case 'PAGE_LOADER':
      return { ...state, pageLoader: action.data }
    default:
      return { ...state }
  }
}
export default conferenceevent
